import {
  IBranch,
  IPaymentMethod,
  ISupportedCurrency,
} from "@/api/AppApi/services/company/interfaces/ICompany";
import { IResultStamp } from "@/api/AppApi/common-interfaces/IResultStamp";
import { DiscountTypes, IProduct } from "../../home/interfaces/IProduct";
import { DeliveryMethodsTypes } from "../../company/interfaces/ICompany";
import { unit } from "../../product/interfaces/api-product-details-interface";
import {
  IAddOnWithQuantity,
  IGroupedBundleItems,
} from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";
export enum CartItemTypes {
  product = "product",
  slot = "slot",
  consultation = "consultation",
  event = "event",
}
export interface IBundleItemsDetails {
  id: 852932;
  name: string;
  sku: string;
  barcode: string;
  type: string;
  image_url: string;
  quantity: number;
  attribute: Record<string, string>;
  price?: number;
}

export interface ICartManageItemParams_Product {
  type: CartItemTypes.product;
  cartId?: number; //used in api /id
  id?: number;
  quantity: number;
  note: string;
  addons: IAddOnWithQuantity[];
  attrs_values: number[];
  other_inputs: object;
  unit_id?: number;
  bundle_items: IGroupedBundleItems[];
}
export interface ICartManageItemParams_Event {
  type: CartItemTypes.event;
  cartId?: number; //used in api /id
  id?: number;
  quantity: number;
  note: string;
  addons: IAddOnWithQuantity[];
  attrs_values: number[];
  other_inputs: object;
  unit_id?: number;
}
export interface IAttachment {
  type: "file" | "voice";
  name: string;
  url: string;
}
export interface ICartManageItemParams_Consult {
  type: CartItemTypes.consultation;
  cartId?: number; //used in api /id
  id: number;
  quantity: number;
  note: string;
  attrs_values: number[];
  message: string;
  files: IAttachment[];
}
export interface ICartManageItemParams_Slot {
  type: CartItemTypes.slot;
  cartId?: number; //used in api /id
  id?: number;
  quantity: number;
  note: string;
  date: string;
  addons?: any[];
  other_inputs: any;
  product_id: number | null;
}
export type ICartManageItemParams =
  | ICartManageItemParams_Product
  | ICartManageItemParams_Slot
  | ICartManageItemParams_Consult
  | ICartManageItemParams_Event;

export interface IAddOn {
  id: number;
  name: string;
  image: string;
  price: number;
  quantity: number;
  key: string;
}
interface ICartItem {
  addons: IAddOn[];
  basic_price: number;
  description: string;
  discount: number;
  can_edit: boolean;
  id: number;
  image_url: string;
  inner_id: number;
  name: string;
  note: string;
  price: number;
  quantity: number;
  tax: number;
  thumbnail_url: string;
  type: CartItemTypes;
  unit_id?: number;
  parent: { name: string; sku: string };
  free_quantity: number;
  categories_names?: string[];
}
export interface ICartItem_Slot extends ICartItem {
  type: CartItemTypes.slot;
  others: {
    data_fields: object;
    date: string; //"2023-01-01";
    end_at: string; //"04:30 pm";
    start_at: string; //"03:30 pm";
  };
}
export interface ICartItem_Consultation extends ICartItem {
  type: CartItemTypes.consultation;
  others: {
    data_fields: object;
    attrs_values: [];
    files: [];
    is_new: boolean;
    message: string;
    parent_id: number | null;
  };
}
export interface ICartItem_Event extends ICartItem {
  type: CartItemTypes.event;
  others: {
    data_fields: object;
    attrs_values: [];
    parent_id: number | null;
  };
}
export interface ICartItem_Product extends ICartItem {
  type: CartItemTypes.product;
  bundle_items: IGroupedBundleItems[];
  bundle_items_details: IBundleItemsDetails[];
  others: {
    data_fields: object;
    attrs_values: {
      id: number;
      name: string;
      type: string;
      key: string;
    }[];
    discount_amount: number;
    discount: number;
    discount_type: DiscountTypes;
    is_configurable: boolean;
    is_new: boolean;
    max_quantity_in_cart: number | null;
    min_quantity_in_cart: number | null;
    parent_id: number | null;
    quantity_on_hand: number;
    unit_id: number;
    units: unit[];
    selling_prices: IProduct["selling_prices"];
  };
}
export interface ICoupon {
  code: string;
  description: string;
  discount: number;
  title: string;
}
export type ICartItemType =
  | ICartItem_Product
  | ICartItem_Slot
  | ICartItem_Consultation
  | ICartItem_Event;
export interface IGetCartResult {
  coupon: ICoupon;
  discount: number;
  gateway_account_id: number;
  gateway_id: number;
  items: ICartItemType[];
  price_zone_id: number;
  shipping_charge: number;
  subtotal: number;
  tax: number;
  total: number;
  settings: { available_delivery_types: DeliveryMethodsTypes[] };
}
export interface IGetCart extends IResultStamp {
  result: IGetCartResult;
}
export interface IShippingMethodResult {
  price_zone_id: number;
  name: string;
  icon: string;
  notes: string;
  delivery_fees: number;
  can_set_delivery_date: boolean;
  is_time_required: boolean;
  is_date_required: boolean;
  time_before_order: number;
  delivery_time: number;
  expected_delivery_time: string;
}
export interface IGetSippingMethods extends IResultStamp {
  result: IShippingMethodResult[];
}
export interface ISetPaymentMethodParams {
  gateway_id: number;
  gateway_account_id: number | null;
  country_code: string;
}
export interface ISubmitCheckoutResult {
  payment_data: {
    track_id: string;
    result: string; //url
    type: string;
  } | null; //payment method=cash:null, payment method=online:{...}
  invoice_number: string;
  invoice_id: number;
  invoice_date: string;
  invoice_time: string;
  amount: number;

  track_id?: number;
  payment_method: string;
  order_number: string | number;
  payment_id: string | number;
  reference_number: string | number;
  currency: ISupportedCurrency;
  event_name?: string;
  cities_names?: string[];
}
export interface ISubmitCheckoutResponse extends IResultStamp {
  result: ISubmitCheckoutResult;
}
export enum PaymentResultTypes {
  paid = "paid",
  failed = "failed",
}
export interface IPaymentResult {
  track_id: string;
  invoice_number: string;
  invoice_id: number;
  invoice_date: string;
  invoice_time: string;
  status: PaymentResultTypes;
  amount: number;
  payment_info?: string;

  payment_method: string;
  order_number: string | number;
  payment_id: string | number;
  reference_number: string | number;
  resource: IResource;
  event_name?: string;
  cities_names?: string[];
}
export interface IPaymentResponse extends IResultStamp {
  result: IPaymentResult;
}

export interface IGetPaymentMethods extends IResultStamp {
  result: IPaymentMethod[];
}

export interface IGetDeliveryBranches extends IResultStamp {
  result: IBranch[];
}

export type PostPaymentMethodAvailable = {
  gateway_account_id: number;
  customer: {
    name: string;
    email: string;
    mobile: {
      number: string;
      country: string;
    };
    other_inputs?: any;
  };
};

export interface IPostPaymentMethodAvailableResult extends IResultStamp {
  result: {
    available: boolean;
    message: string;
  };
}

export interface IResource {
  id: number;
  invoice_number: string;
  due_date: Date;
  total: number;
  unpaid_amount: number;
  delivery_info: DeliveryInfo;
  status: string;
  order_status: string;
  is_cash_payment: boolean;
  invoice_date: Date;
  items: Item[];
  items_count: number;
  addons_count: null;
  others: any[];
  currency: ISupportedCurrency;
  subtotal: number;
  shipping_charge: number;
  discount: number;
}

interface DeliveryInfo {
  is_delivery: boolean;
  delivery_date: Date;
  delivery_time: string;
  country_code?: string | null;
}
interface Item {
  id: number;
  name: string;
  description: string;
  thumbnail: string;
  sold_quantity: number;
  quantity: number;
  price: number;
  discount: number;
  total: number;
  note: string;
  sku: string;
  type: string;
  others: null;
}
